import { render } from "./MemberPage.vue?vue&type=template&id=a8e4118a&scoped=true"
import script from "./MemberPage.vue?vue&type=script&lang=js"
export * from "./MemberPage.vue?vue&type=script&lang=js"

import "./MemberPage.vue?vue&type=style&index=0&id=a8e4118a&scoped=true&lang=css"

import exportComponent from "/home/runner/work/ipc-app/ipc-app/apps/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8e4118a"]])

export default __exports__